export const useFirstPathSegment = (): string => {
  const path = window.location.pathname;
  // Strip the leading slash and get the first segment of the path.
  const end = path.indexOf('/', 1);
  return path.slice(1, end < 0 ? undefined : end);
};
